<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Recurring Invoice Report</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="row">
            <div class="col-xl-6 my-2" style="height: fit-content;">
                <!-- <button class="btn btn-secondary " (click)="refresh()">
                    <i class="fa fa-refresh"> </i> Refresh
                </button> -->
                <app-button (refreshClicked)="refresh()" ></app-button>

            </div>
        </div>
        <form [formGroup]="RecInvReport">
            <div class="row my-4 mx-3">
                <div class="col-6">
                    <div class="row">
                        <div class="col-12">
                            <span class="title_header_bar2"
                                style="border-top-left-radius:8px;border-top-right-radius:8px">Invoice Report</span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="row my-3 d-flex justify-content-center">
                            <div class="col-xl-9">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>Billing Period Month</mat-label>
                                    <input readonly matInput [matDatepicker]="startDate" id="startDate"
                                        formControlName="startDate" autocomplete="off"
                                        placeholder="Billing Period Month" class="col-12 custom-input-border"
                                        specialIsAlphaNumeric required (click)="FnstartDatePicker()"
                                        style="color:black;" [min]="minDate" [max]="maxDate">
                                    <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">

                                            </svg>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #startDate startView="multi-year"
                                        (monthSelected)="setMonthAndYear($event, startDate)"
                                        panelClass="example-month-picker">
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row text-right ">
                            <div class="col-xl-12 ">
                                <button class="btn btn-primary " (click)="Report()">Generate Report
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-6">
                    <div class="row">
                        <div class="col-12 ">
                            <span class="title_header_bar2"
                                style="border-top-left-radius:8px;border-top-right-radius:8px">Submit Invoice to Money
                                Works </span>
                        </div>
                    </div>
                    <div class="card card_content">
                        <div class="row d-flex justify-content-center my-3">
                            <div class="col-xl-9">
                                <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                    <mat-label>Recurring Billing Month</mat-label>
                                    <input readonly matInput [matDatepicker]="approveDate" id="approveDate"
                                        formControlName="approveDate" autocomplete="off"
                                        placeholder="Recurring Billing Month" class="col-12 custom-input-border"
                                        specialIsAlphaNumeric required (click)="FnApproveDatePicker()"
                                        style="color:black;" [min]="minDate" [max]="maxDate">
                                    <mat-datepicker-toggle matSuffix [for]="approveDate" style="color:black;">
                                        <button mat-icon-button>
                                            <mat-icon>event</mat-icon>

                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">

                                            </svg>
                                        </button>
                                    </mat-datepicker-toggle>
                                    <mat-datepicker #approveDate startView="multi-year"
                                        (monthSelected)="setApproveMonthAndYear($event, approveDate)"
                                        panelClass="example-month-picker">
                                    </mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row text-right">
                            <div class="col-xl-12">
                                <button class="btn btn-primary" (click)="SubmitMWRecInv()">Submit MW Recurring Invoice
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>